<script setup>
let props = defineProps({
    tabs: Object,
});

function redirect(event) {
    window.location.href = event.target.value;
}
</script>

<template>
    <div>
        <div class="md:hidden">
            <label for="tabs" class="sr-only">Select a tab</label>
            <select
                id="tabs"
                name="tabs"
                @change="redirect($event)"
                class="block h-11 w-full rounded border-r-10 border-transparent bg-wgn-purple-3 px-4 text-white"
            >
                <option
                    :value="tab.href"
                    :selected="tab.current"
                    v-for="tab in tabs"
                >
                    {{ tab.name }}
                </option>
            </select>
        </div>
        <div class="hidden md:block">
            <nav
                class="m-auto flex w-fit items-center space-x-0.5 rounded bg-wgn-purple-3 p-0.5"
                aria-label="Tabs"
            >
                <a
                    v-for="tab in tabs"
                    :href="tab.href"
                    class="w-auto rounded py-2 px-8 text-center text-sm text-white hover:bg-wgn-purple-2 focus:z-10 md:px-4 lg:px-8"
                    :class="tab.current ? ' bg-wgn-purple-2' : ''"
                >
                    <span>{{ tab.name }}</span>
                </a>
            </nav>
        </div>
    </div>
</template>
